import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "relative flex max-h-full w-full max-w-2xl flex-col overflow-y-auto rounded-xl bg-dark-gray-200 shadow-xl",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "flex flex-col gap-3 px-6 pb-4" }

import FadeTransition from '@/components/transitions/FadeTransition.vue';
import SectionDetailHeader from './SectionDetailHeader.vue';
import type { SectionRow } from './sectionRow';


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailModalShell',
  props: {
    section: {},
    sections: {}
  },
  emits: ["close", "navigate", "handleAlarm"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(FadeTransition, null, {
      default: _withCtx(() => [
        (_ctx.section)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-[1030] flex items-center justify-center bg-black/40 p-4",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (emit('close')), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(SectionDetailHeader, {
                  section: _ctx.section,
                  sections: _ctx.sections,
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
                  onNavigate: _cache[1] || (_cache[1] = ($event: any) => (emit('navigate', $event))),
                  onHandleAlarm: _cache[2] || (_cache[2] = ($event: any) => (emit('handleAlarm', $event)))
                }, null, 8, ["section", "sections"]),
                _createElementVNode("div", _hoisted_2, [
                  _renderSlot(_ctx.$slots, "default", { section: _ctx.section })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})